import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { getRegistrationTypeListAPI } from '../../../services/conference-details-service';

const initialState = {
    registrationTypeList: undefined
};

export const getRegistrationTypeList = createAsyncThunk(
  'conferenceDetails/getRegistrationTypeList',
  async (thunkAPI) => {
    try {
      const resp = await getRegistrationTypeListAPI();

      return resp;
    } catch (error) {
      return thunkAPI.rejectWithValue('something went wrong');
    }
  }
);

const conferenceRegistrationTypeListSlice = createSlice({
  name: 'registrationTypeList',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getRegistrationTypeList.fulfilled, (state, action) => {
        state.registrationTypeList = action.payload?.items;
      })
      .addCase(getRegistrationTypeList.rejected, (state, action) => {
        state.registrationTypeList = [];
      });;
  },
});

export default conferenceRegistrationTypeListSlice.reducer;
